export const setSchools = (state, info) => {
  console.log('schools --> ', info)
  state.schools = info
}
